import Vue from "vue"
import Vuex from 'vuex'
import restaurants from './restaurants'
import restaurateurs from './restaurateurs'
import drivers from './drivers'
import alerts from './alerts'
import areas from './areas'
import shared from './shared'
import posts from './posts'
import replies from './replies'
import shifts from './shifts'
import timesheets from './timesheets'
import options from './options'
import invoices from './invoices'
import user from './user'
import socketObserver from './socket-observer';
import reporting from './reporting';
Vue.use(Vuex)


export default new Vuex.Store({

    modules: {
        restaurants, restaurateurs, drivers, alerts,
        areas, shared, posts, replies, shifts,
        timesheets, socketObserver, options, invoices,
        user, reporting
    },

})